import styled from 'styled-components';

const TabsContainer = styled.div`
  align-self: center;
`;

export default TabsContainer;